export enum SidebarMenuEnum {

  DASHBOARD ="DASHBOARD",
  TEAM_HEALTH = "TEAM_HEALTH",
  GAMIFICATION ="GAMIFICATION",
  GAMIFICATION_V2 ="GAMIFICATION_V2",
  GITWISER = "GITWISER",
  QWISER = "QWISER",
  AGILESPACE = "AGILESPACE",
  EXECUTIVE_DASHBOARD = "EXECUTIVE_DASHBOARD",
  PROFILE = "PROFILE",
  DATASOURCES = 'DATASOURCES',
  INTEGRATIONS = 'INTEGRATIONS',
  ADMINISTRATION =  'ADMINISTRATION',
  BUG_REPORT =  'BUG_REPORT'
}
